
            const data = {"name":"icon-plus","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M.9 17a.5.5 0 110-1H31a.5.5 0 110 1H1z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M16 31.1a.5.5 0 11-1 0V1a.5.5 0 111 0v30z\"/>"}}
        
                module.exports = data
                